module.exports = __webpack_public_path__ + "img/67_24.ea93af56.png";